import React from 'react';

const t = {
  en: {
    blurb: 'Eleverse is a learning and games website with first-class content for cognitive learning and play.',
    rights: 'All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms',
    imprint: 'Imprint',
    contact: 'Contact',
    faq: 'FAQ',
  },
  de: {
    blurb: 'Eleverse ist eine Lern- und Spielewebsite. Wir bieten erstklassige Inhalte zur idealen Förderung von kognitiven Lern- und Spielerfahrungen.',
    rights: 'Alle Rechte vorbehalten.',
    privacy: 'Datenschutz',
    terms: 'AGB',
    imprint: 'Impressum',
    contact: 'Kontakt',
    faq: 'FAQ',
  },
};

export default function Footer({ lang }) {
  const tx = t[lang];

  return (
    <footer
      className="py-10 px-6"
      style={{
        backgroundColor: '#080a10',
        borderTop: '1px solid rgba(59,130,246,0.1)',
      }}
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + blurb */}
        <div className="flex flex-col items-center md:items-start gap-1">
          <a href="/" className="flex items-center gap-1">
            <span
              className="text-xl font-black uppercase tracking-tighter"
              style={{ color: '#3b82f6', letterSpacing: '-0.03em' }}
            >
              Eleverse
            </span>
          </a>
          <p className="text-xs" style={{ color: '#475569' }}>{tx.blurb}</p>
        </div>

        {/* Links */}
        <div className="flex items-center gap-6">
          {[
            { label: tx.privacy, href: '/privacy.html' },
            { label: tx.terms, href: '/terms.html' },
            { label: tx.imprint, href: '/impressum.html' },
            { label: tx.contact, href: '/kontakt.html' },
            { label: tx.faq, href: '/faq.html' },
          ].map((link, i) => (
            <a
              key={i}
              href={link.href}
              className="text-sm transition-colors hover:text-blue-400"
              style={{ color: '#475569' }}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p className="text-sm" style={{ color: '#334155' }}>
          © {new Date().getFullYear()} Eleverse Labs AG. {tx.rights}
        </p>
      </div>
    </footer>
  );
}
